import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { palette } from "./palette";
import { useHomepageSeo } from "./seo";
import SiteHeader from "./sections/SiteHeader";
import Hero from "./sections/Hero";
import Honest from "./sections/Honest";
import Journey from "./sections/Journey";
import Curriculum from "./sections/Curriculum";
import TheFifty from "./sections/TheFifty";
import WhoWeAre from "./sections/WhoWeAre";
import Projects from "./sections/Projects";
import FAQ from "./sections/FAQ";
import FinalCTA from "./sections/FinalCTA";
import SiteFooter from "./sections/SiteFooter";
import RegisterPopup from "./RegisterPopup";
import TopAlert from "./TopAlert";

const HomepageNew = () => {
  const [registerOpen, setRegisterOpen] = useState(false);

  useHomepageSeo();

  // The app's global theme (src/theme.js) paints the body #f9fafb. This page is
  // warmer than that, so match it while mounted and restore it on unmount.
  useEffect(() => {
    const previous = document.body.style.backgroundColor;
    document.body.style.backgroundColor = palette.bg;
    return () => {
      document.body.style.backgroundColor = previous;
    };
  }, []);

  const openRegister = () => setRegisterOpen(true);

  return (
    <Box sx={{ backgroundColor: palette.bg, color: palette.text, minHeight: "100vh" }}>
      <TopAlert onClick={openRegister} />
      <SiteHeader onRegister={openRegister} />

      <Box component="main">
        <Hero onRegister={openRegister} />
        <WhoWeAre />
        <Honest />
        <Journey />
        <Curriculum />
        <TheFifty />
        <Projects />
        <FAQ />
        <FinalCTA onRegister={openRegister} />
      </Box>

      <SiteFooter />

      <RegisterPopup open={registerOpen} onClose={() => setRegisterOpen(false)} />
    </Box>
  );
};

export default HomepageNew;
